const drawInteractionLines = (container, connections = [], onDrag, onClick) => {
  let linesLayer = container.select(".lines-layer");
  if (linesLayer.empty()) {
    linesLayer = container.append("g").classed("lines-layer", true);
  }

  // Clear existing lines to ensure a clean redraw
  linesLayer.selectAll("line.connection").remove();
  linesLayer.selectAll("line.hitbox").remove();

  connections.forEach((connectionGroup, groupIndex) => {
    // sort the interactions by their position X value to draw the lines in the correct order
    const seq = [...connectionGroup.interactions].sort(
      (a, b) => a.absPos.x - b.absPos.x
    );
    // Now form set of pairs of interactions to draw lines between
    const pairs = [];
    for (let i = 0; i < seq.length - 1; i++) {
      pairs.push([seq[i], seq[i + 1]]);
    }

    // Draw the lines - use unique selector for each connection group
    const lines = linesLayer
      .selectAll(`line.connection-${groupIndex}`)
      .data(pairs)
      .join(
        (enter) =>
          enter
            .append("line")
            .classed("connection", true)
            .classed(`connection-${groupIndex}`, true)
            .attr("data-id", (d) => `${d[0].id}-${d[1].id}`)
            .attr("data-connection-id", () => connectionGroup.id)
            .attr("data-from", (d) => d[0].id)
            .attr("data-to", (d) => d[1].id)
            .attr("cursor", "pointer")
            .on("click", (event, d) => {
              event.stopPropagation(); // Prevent event propagation
              console.log("onClick (connection)", connectionGroup, groupIndex);
              onClick({ ...connectionGroup, ...d });
            }),

        (update) => update,
        (exit) => exit.remove()
      );

    // Add hitboxes - use unique selector for each connection group

    const hitboxes = linesLayer
      .selectAll(`line.hitbox-${groupIndex}`)
      .data(pairs)
      .join(
        (enter) =>
          enter
            .append("line")
            .classed("hitbox", true)
            .classed(`hitbox-${groupIndex}`, true)
            .attr("data-id", (d) => `${d[0].id}-${d[1].id}`)
            .attr("data-connection-id", () => connectionGroup.id)
            .attr("data-from", (d) => d[0].id)
            .attr("data-to", (d) => d[1].id)
            .attr("stroke", "rgba(0,0,0,0.01)") // Nearly transparent but still interactive
            .attr("stroke-width", 16) // Wider hitbox for easier clicking
            .attr("fill", "none") // Ensure no fill
            .attr("cursor", "pointer") // Match the connection cursor
            .attr("pointer-events", "stroke") // Ensure stroke area captures events
            .on("click", (event, d) => {
              const segmentId = `${d[0].id}-${d[1].id}`;
              event.stopPropagation(); // Prevent event propagation
              console.log("onClick (hitbox)", segmentId, connectionGroup);
              onClick({
                ...connectionGroup,
                segment: { id: segmentId, from: d[0], to: d[1] },
                ...d,
              });
            }),

        (update) => update,
        (exit) => exit.remove()
      );

    lines
      .attr("x1", (d) => d[0].absPos.x + d[0].size.width)
      .attr("y1", (d) => d[0].absPos.y + d[0].size.height / 2)
      .attr("x2", (d) => d[1].absPos.x)
      .attr("y2", (d) => d[1].absPos.y + d[1].size.height / 2);

    hitboxes
      .attr("x1", (d) => d[0].absPos.x + d[0].size.width)
      .attr("y1", (d) => d[0].absPos.y + d[0].size.height / 2)
      .attr("x2", (d) => d[1].absPos.x)
      .attr("y2", (d) => d[1].absPos.y + d[1].size.height / 2);
  });
};

export { drawInteractionLines };
